if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        window.requestAnimationFrame(() => {
          activeMedia.scrollIntoView({ inline: 'center', block: 'nearest' });

          const container = this.querySelector('[role="document"]');
          if (container) {
            const mediaWidth = activeMedia.offsetWidth || activeMedia.getBoundingClientRect().width;
            if (mediaWidth) {
              const targetScrollLeft = Math.max(
                0,
                activeMedia.offsetLeft - (container.clientWidth - mediaWidth) / 2
              );
              container.scrollTo({ left: targetScrollLeft, behavior: 'auto' });
            }
          }
        });

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
